import {
    GET_ALL_PAYMENT_TYPES,
} from '../actions/PaymentTypeActions'

const initialState = {
    data: [],
    allPaymentTypes: [],
    latestUpdate: '',
    loading: false,
    error: '',
}

const PaymentTypeReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_ALL_PAYMENT_TYPES: {
            return {
                ...state,
                allPaymentTypes: action.payload,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default PaymentTypeReducer
